module.exports = __webpack_public_path__ + "static/media/megabus-ticket-lookup.7ab055ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/megabus-ticket-lookup.svg
// module id = 746
// module chunks = 0